import { useNavigate } from "react-router-dom";
import { Building2, UtensilsCrossed, Hotel, Store, Briefcase, ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";

const GLASS = "https://images.pexels.com/photos/20677918/pexels-photo-20677918.jpeg?auto=compress&cs=tinysrgb&w=1600";
const targets = ["Restaurants", "Hotels", "Cafes", "Offices", "Retail stores", "Showrooms", "Hospitals", "Hospitality", "Commercial properties"];
const useCases = ["Tabletops", "Countertops", "Reception Desks", "Furniture", "Glass", "Bathrooms", "Kitchens", "High-traffic Surfaces"];

export default function ForBusiness() {
  const navigate = useNavigate();
  return (
    <div data-testid="for-business-page">
      <Seo title="ERRAH for Business" description="Commercial surface protection for restaurants, hotels, offices, retail and hospitality." />
      <section className="relative min-h-[60vh] flex items-center overflow-hidden">
        <img src={GLASS} alt="Commercial space" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          <p className="errah-label gold-text mb-4">For business</p>
          <h1 className="font-display text-5xl lg:text-7xl font-light tracking-tighter leading-none">ERRAH for<br />Business.</h1>
          <p className="mt-6 text-gray-300 max-w-xl">Protect high-traffic surfaces at scale — engineered protection for hospitality and commercial environments.</p>
          <button onClick={() => navigate("/quote", { state: { property_type: "Commercial", source: "Website" } })} data-testid="business-assessment-cta"
            className="mt-8 inline-flex items-center gap-2 bg-[#C9A45C] text-black px-7 py-3.5 text-sm font-semibold hover:bg-[#E4C987] transition-colors">
            REQUEST A COMMERCIAL ASSESSMENT <ArrowRight size={16} />
          </button>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-20">
        <Reveal><p className="errah-label mb-8">Who we protect</p></Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-white/10">
          {[Building2, UtensilsCrossed, Hotel, Store, Briefcase, Building2].map((Icon, i) => (
            <div key={i} className="bg-[#0A0A0A] p-8 flex items-center gap-4">
              <Icon className="text-[#C9A45C]" size={24} />
              <span className="text-gray-300">{targets[i]}</span>
            </div>
          ))}
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {targets.slice(6).map((t) => <span key={t} className="px-4 py-2 text-sm border border-white/15 text-gray-400">{t}</span>)}
        </div>

        <Reveal><h2 className="font-display text-3xl mt-20 mb-8">Use cases</h2></Reveal>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {useCases.map((u, i) => (
            <Reveal key={u} delay={(i % 4) * 0.06}>
              <div className="hair-border bg-white/[0.02] px-6 py-10 text-center hover:bg-white/[0.04] transition-colors">
                <span className="font-display text-lg">{u}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
